module.exports = __webpack_public_path__ + "static/media/skinHazardousarts.75b9f637.jpg";